import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { MaskedPassword } from './maskedPassword';
import { PasswordDetailsDialog } from './passwordDetailsDialog/passwordDetailsDialog';
import { PolicyHolderPropTypes } from '../../../../propTypes/petDetails';
import { SuccessMessageDialog } from '../../../successMessage/successMessageDialog';
import { SUCCESS_MESSAGES } from '../../../../constants/constants';
import { singlePetSuccessMessage } from '../../../../utils/successMessages';

export const PasswordDetails = ({ policyHolder, numPolicyHolders = 1 }) => {
  const [isDialogShowing, setIsDialogShowing] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const fieldFormContext = useFormContext();

  const handleChangePassword = () => {
    setIsDialogShowing(true);
  };

  const { email } = policyHolder;

  return (
    <div className="policyHolderDetail">
      <h3>My portal login details</h3>
      <div className="personalDetails loginDetails">
        <div className="fieldGroup">
          <div className="labelValueText">
            <span>
              <strong>Email</strong>
            </span>
            <span>
              <em>{email}</em>
            </span>
          </div>
          <div className="labelValueText">
            <span>
              <strong>Password</strong>
            </span>
            <span>
              <MaskedPassword />
            </span>
          </div>
        </div>
        <button
          type="button"
          onClick={handleChangePassword}
          className="button primary outline"
        >
          <Icon icon="pencil" />
          <span className="labelText">Update</span>
          <span className="sr-only"> password</span>
        </button>
      </div>

      {isDialogShowing && (
        <PasswordDetailsDialog
          policyHolder={policyHolder}
          fieldFormContext={fieldFormContext}
          onClose={() => setIsDialogShowing(false)}
          setShowSuccessMessage={setShowSuccessMessage}
        />
      )}
      {showSuccessMessage && (
        <SuccessMessageDialog
          message={`${singlePetSuccessMessage()}${numPolicyHolders > 1 ? SUCCESS_MESSAGES.MULTI_PET : ''}`}
          onClose={() => setShowSuccessMessage(false)}
        />
      )}
    </div>
  );
};

PasswordDetails.propTypes = {
  policyHolder: PolicyHolderPropTypes,
  numPolicyHolders: PropTypes.number
};
